// © Microsoft Corporation. All rights reserved.

/**
 * Contract related to local dev workflow
 */
export enum ConfigOrigin {
    // Configs are fetched from remote
    Production = 0,

    // Configs are fetched from local file system
    Local = 1
}

/**
 * Contract related to local dev workflow
 */
export interface ConfigOrigins {
    /** feature config */
    feature: ConfigOrigin;

    /** localization config origin*/
    loc: ConfigOrigin;
}